import { render, staticRenderFns } from "./Estadisticas2022.vue?vue&type=template&id=05ebea16"
import script from "./Estadisticas2022.vue?vue&type=script&lang=js"
export * from "./Estadisticas2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports